import React from "react";

import styles from "./BlueBoxTitle.module.css";

interface BlueBoxTitleProps {
    content: string,
    upper?: boolean
}

export default function BlueBoxTitle(props: BlueBoxTitleProps){
    return (
        <div className={`${styles.titleBox} ${props.upper && styles.upper}`}><span>{props.content}</span></div>
    )
}